import config from '../../config.js'
export default {
	'actual-amount-of-cardamom': `${config['actual-amount-of-cardamom'].en}`,
	'cardamom-is-restricted-to-sorting': `${config['cardamom-is-restricted-to-sorting'].en}`,
	'remaining-qty': 'Remaining Qty',
	'total-sales': 'Total sales',
	'sale-balance': 'Expected qty',
	'sale-balance-table': 'Expected balance',
	'items-in-inventory': 'Ready items',
	'inventory-qty': 'Inventory qty',
	'available-to-sell': 'Able to sell'

}